import React from 'react';
import { FaRegCheckSquare } from 'react-icons/fa';
import { Button } from 'utils/Button';

const ReusableSectionTwo = ({
  title,
  subtitle,
  content,
  buttonText,
  buttonLink
}) => {
  return (
    <div className="max-w-[1200px] mx-auto grid lg:grid-cols-[60%_40%] px-6 pt-16 lg:-mb-28">
      <div className="h-max">
        <h2 className="uppercase text-[27px]">{title}</h2>
        <div className="w-full h-[4px] my-4 bg-blue-800 bg-opacity-50"></div>
        <h3 className="mt-8 text-lg uppercase">{subtitle}</h3>
        {content.map((item, index) => (
          <p className="pt-4" key={index}>
            {item}
          </p>
        ))}
      </div>
      <div 
        className="border-4 h-max lg:ml-10 p-11 border-blue-800 border-opacity-50 relative mt-10 lg:mt-0 lg:-top-[22%] flex flex-wrap content-start pb-[84px]"
        style={{ 
          '--bg-color': '#ffffff',
          backgroundColor: 'var(--bg-color)',
          backgroundImage: 'none',
          background: 'var(--bg-color)',
          position: 'relative',
          zIndex: 20,
          transform: 'none',
          isolation: 'isolate'
        }}
      >
        <h2 className="mx-auto xl:mx-0 mb-6 text-[27px] uppercase">
          Want to remodel your home?
        </h2>
        <p className="mb-6">
          Experts in design/build, cabinets, kitchens, bathrooms, custom
          woodwork, whole houses, and everything in between for home
          renovations.
        </p>
        <div className="w-10/12 mx-auto mb-6">
          {checklist.map((item, index) => (
            <div className="flex flex-wrap p-2" key={index}>
              <div className="relative">
                <FaRegCheckSquare className="absolute mt-1 text-blue-800 -left-6" />
                {item}
              </div>
            </div>
          ))}
        </div>
        <Button
          text={buttonText}
          to={buttonLink}
          classname="left-1/2 absolute bottom-10 -translate-x-[50%]"
        />
      </div>
    </div>
  );
};

export default ReusableSectionTwo;
const checklist = [
  '35+ years of experience',
  'Free Consultations',
  '100% Customer Satisfaction',
  'Serving Weber, Davis, and Box Elder counties, Utah'
];
